import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';

import {localeReducer} from 'react-localize-redux';

import reportState from './reportDataReducer';
import liveTrackingState from './liveTrackingReducer';
import pastOrderState from './pastOrderReducer';
import authState from './authReducer'

const rootReducer = combineReducers({
  routing: routerReducer,
  locale: localeReducer,
    reportState,
    liveTrackingState,
    pastOrderState,
    authState
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js